<div class="com-table-container" [class.com-chart-container]="isChartRoute$ | async">
  <router-outlet></router-outlet>
</div>
